import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import AppSettings from "../../../../Settings/AppSettings";
import { CategoryContext } from "../CategoryContext";
import { List, arrayMove } from "react-movable";
import Label from "../../../Common/components/Label";
import GMSBorderlessButton from "../../../Common/components/GMSBorderlessButton";
import SmallOutlinedButton from "../../../Common/components/SmallOutlinedButton";
import SmallFillButton from "../../../Common/components/SmallFillButton";
import { toast } from "react-toastify";
import { AppContext } from "../../../../Context/AppContext";
import LoadingSuccessErrorAlert from "./LoadingSuccessErrorAlert";

const RelevantCategories = () => {
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const categoryTypeContextData = useContext(CategoryContext);
  const [loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const appData = useContext(AppContext);
  const [list, setList] = useState(null);
  const [EditPage, setEditPage] = useState(false);
  const [collapse, setCollapse] = useState(false);
  let [relevantCategories, setRelevantCategories] = useState(null);
  useEffect(() => {
    setRelevantCategories(null);
    setLoading({
      status: "",
      message: "",
    });
  }, [categoryTypeContextData.editingItem.id]);

  useEffect(() => {
    if (list === null && collapse) {
      load_associated_rel_cat();
    }
  }, [collapse]);
  useEffect(() => {
    if (EditPage) {
      load_associated_rel_cat();
    }
  }, [EditPage]);

  async function load_associated_rel_cat() {
    setLoading({ status: "Loading", message: "Loading Relevant Categories" });
    let res = await ServiceWrapper.doGet(
      `${api_base_url}category/${categoryTypeContextData.editingItem.id}/relevantcategories/list`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      setLoading({ status: "Success", message: undefined });
      setRelevantCategories(res.data.data);
      setList(res.data.data);
    } else {
      setLoading({ status: "Error", message: "Error while loading details" });
    }
  }

  function handle_collapse() {
    setCollapse(!collapse);
  }

  async function handle_save() {
    setLoading({
      status: "Loading",
      message: "Saving new order for Relevant Categories",
    });
    let newOrder = [];
    list.map((item, index) => {
      newOrder.push({
        id: item.id,
        rank: `${index + 1}`,
      });
    });

    let res = await ServiceWrapper.doPost(
      `${api_base_url}category/${categoryTypeContextData.editingItem.id}/relevantcategories/edit`,
      newOrder,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      if (res.data.done) {
        setLoading({
          status: "Success",
          message: res.data.message,
        });
        setEditPage(false);
        load_associated_rel_cat();
      } else {
        setLoading({
          status: "Error",
          message: res.data.message,
        });
      }
    } else {
      setLoading({
        status: "Error",
        message: "Error while saving, Please try after some time.",
      });
    }
    setTimeout(() => {
      if (loading.status !== "Success")
        setLoading({
          status: "",
          message: "",
        });
    }, 5000);
  }

  function handle_cancel() {
    setEditPage(false);
    setList(relevantCategories);
  }

  return (
    <>
      <div className="accordion" id="accordionFlushCate">
        <div className="border-0 accordion-item">
          <div
            className="bg-white shadow-none accordion-button collapsed"
            onClick={() => handle_collapse()}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#flush-collapseCat"
            aria-controls="flush-collapseCat"
            // style={Utils.borderStyle()}
            style={{
              height: "2.6875rem",
              border: "1px solid #c9cccf",
            }}
          >
            <div>
              {EditPage ? <Label message="Update" /> : ""}{" "}
              <Label message="Relevant Categories" />
            </div>
          </div>

          {collapse && (
            <>
              {loading.status === "Success" && (
                <>
                  {!EditPage ? (
                    <div
                      className="d-inline-block d-flex float-end position-relative"
                      style={{
                        zIndex: "100",
                        marginTop: "-34px",
                        marginRight: "30px",
                      }}
                    >
                      &nbsp;
                      {relevantCategories && relevantCategories.length > 1 && (
                        <GMSBorderlessButton
                          name="Edit"
                          onClick={() => {
                            if (
                              appData.pm.checkPermission("gmscategory_update")
                            ) {
                              setEditPage(true);
                            } else {
                              toast.info(
                                "You don't have permission to edit relevant category"
                              );
                            }
                          }}
                        />
                      )}
                    </div>
                  ) : (
                    <div
                      className="d-inline-block d-flex float-end position-relative"
                      style={{
                        zIndex: "100",
                        marginTop: "-34px",
                        marginRight: "30px",
                      }}
                    >
                      <GMSBorderlessButton
                        name="Reset"
                        onClick={() => setList(relevantCategories)}
                        disabled={
                          JSON.stringify(relevantCategories) ===
                          JSON.stringify(list)
                        }
                      />
                      &nbsp;
                      <SmallOutlinedButton
                        name="Cancel"
                        onClick={() => {
                          handle_cancel();
                        }}
                      />
                      &nbsp;
                      <SmallFillButton
                        name="Save"
                        disabled={
                          JSON.stringify(relevantCategories) ===
                          JSON.stringify(list)
                        }
                        onClick={() => handle_save()}
                      />
                    </div>
                  )}
                </>
              )}
            </>
          )}

          <div
            id="flush-collapseCat"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingCat"
            data-bs-parent="#accordionFlushCate"
          >
            <div className="p-0 accordion-body" style={{ minHeight: "30px" }}>
              <LoadingSuccessErrorAlert loading={loading} />

              {loading.status === "Success" && (
                <>
                  {EditPage ? (
                    <div
                      className="p-2 card bg-body"
                      style={{
                        borderBottom: "1px solid #c9cccf",
                        borderLeft: "1px solid #c9cccf",
                        borderRight: "1px solid #c9cccf",
                        borderTop: "none",
                      }}
                    >
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th
                              className="border-0"
                              scope="col"
                              style={{
                                fontFamily: "Noto Sans",
                                fontSize: "0.875rem",
                                fontWeight: 400,
                                paddingBottom: "13px",
                                color: "#787878",
                              }}
                            >
                              Relavant Categories Order Ranking
                            </th>
                          </tr>
                        </thead>
                        <List
                          values={list}
                          onChange={({ oldIndex, newIndex }) =>
                            setList(arrayMove(list, oldIndex, newIndex))
                          }
                          renderList={({ children, props }) => (
                            <tbody {...props}>{children}</tbody>
                          )}
                          renderItem={({ value, props }) => (
                            <tr
                              style={{
                                backgroundColor:
                                  props.key % 2 === 0 ? "white" : "white",
                              }}
                            >
                              <td className="border-0" {...props}>
                                <span className="Rectangle-43">
                                  <img
                                    alt="img"
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/img/Group 17.svg"
                                    }
                                    className="Group-17"
                                  />
                                  {props.key !== undefined &&
                                    `${props.key + 1}. `}
                                  {value.name}
                                </span>
                              </td>
                            </tr>
                          )}
                          transitionDuration={100}
                          lockVertically={true}
                        />
                      </table>
                    </div>
                  ) : (
                    <div
                      className="p-3"
                      style={{
                        borderBottom: "1px solid #d6d8d9",
                        borderRight: "1px solid #d6d8d9",
                        borderLeft: "1px solid #d6d8d9",
                        borderTop: "none",
                      }}
                    >
                      {relevantCategories && relevantCategories.length > 0 ? (
                        <table className="table table-sm">
                          <tbody>
                            {relevantCategories.map((item, index) => {
                              let relevantCategory = `${index + 1}  ${
                                item.name
                              }`;
                              return (
                                <tr key={index}>
                                  <Label
                                    message={relevantCategory}
                                    fontWeight="400"
                                    fontSize={0.75}
                                    color="#5c5f62"
                                    fontFamily="Noto Sans"
                                  />
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      ) : (
                        <div
                          className="p-2 bg-white alert alert-dark small"
                          role="alert"
                        >
                          <strong>Relevant Categories Not Found</strong>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default RelevantCategories;
